import { Icon } from '../icons/Icon.jsx';

/* 확인(삭제 등) 다이얼로그 */
export function Confirm({ title, body, confirmLabel, onConfirm, onClose }) {
  return (
    <div className="veil" onMouseDown={onClose}>
      <div className="modal confirm" onMouseDown={e => e.stopPropagation()}>
        <div className="confirm__icon"><Icon name="trash" size={24} /></div>
        <div className="confirm__t">{title}</div>
        <div className="confirm__d">{body}</div>
        <div className="confirm__actions">
          <button className="btn btn--ghost" onClick={onClose}>취소</button>
          <button className="btn btn--danger" onClick={onConfirm}>{confirmLabel || '삭제'}</button>
        </div>
      </div>
    </div>
  );
}

export default Confirm;
